<template>
  <div class="login-content-box">
    <div class="login-content-box-1">
      <div class="login-content-box-1-top">
        <p class="p2 active" @click="linkEx2">密码登录</p>
        <p class="p2" @click="linkEx">验证码登录</p>
      </div>
      <div class="login-content-box-1-bottom">
        <Form
          class="F"
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          @keyup.enter.native="handleSubmit('formInline')"
        >
          <FormItem class="F-1" prop="phone">
            <Input class="I" type="text" v-model="formInline.phone" placeholder="手机号" />
          </FormItem>
          <FormItem class="F-1" prop="password">
            <Input class="I" type="password" v-model="formInline.password" placeholder="密码" />
          </FormItem>
          <div class="F-2">
            <p class="F-2-text" @click="$router.push('/login/reset-password')">忘记密码</p>
          </div>
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            size="large"
            :loading="loading"
          >登录</Button>
          <p class="login-re">
            <span @click="$router.push('/login/register')">没有账号？立即注册</span>
          </p>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "a-login",
  data() {
    return {
      loading: false,
      formInline: {
        phone: "",
        password: ""
      },
      ruleInline: {
        phone: validator.phone,
        password: [
          {
            required: true,
            message: "您输入的密码和手机号不匹配",
            trigger: "blur"
          },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 12,
            message: "密码不能大于于12位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  async created() {}, 
  methods: {
    ...mapMutations({
      setUser: "setUser",
      setToken: "setToken",
      setLogin: "setLogin",
      setTokenTime: "setTokenTime"
    }),
    ...mapActions({
      getUser: "loginModule/getUser",
      getToken: "loginModule/getToken"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let formData = {
        username: form.phone,
        password: form.password,
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        scope: "synair offline_access",
        login_type: "phone"
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.$Message.success("登录成功");
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        this.setLogin(true);
        this.$router.push("/home");
      }
      this.loading = false;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    linkEx() {
      this.$router.push("/login/blogin");
    },
    linkEx2() {
      this.$router.push("/login/alogin");
    }
  }
};
</script>

<style lang='scss'>
.login-content-box {
  width: 420px;
  min-height: 392px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(100, 100, 100, 0.38);
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  &-1 {
    width: 420px;
    min-height: 348px;
    background-color: #fff;
    border-radius: 2px;
    position: relative;
    &-top {
      width: 332px;
      height: 40px;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }
      .p2 {
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        cursor: pointer;
        color: #666;
        &.active,
        &:hover {
          color: #d13119;
        }
      }
      .p3 {
        color: #808080;
        &:hover {
          color: #d13119;
        }
      }
    }
    &-bottom {
      width: 360px;
      min-height: 350px;
      margin: 0 auto;
    }
  }
  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    img {
      width: 13px;
      height: 11px;
    }
  }
}
.F {
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 350px;
  position: relative;
  .ivu-input {
    height: 42px;
  }
  &-1 {
    margin-top: 15px;
    margin-bottom: 0;
    .I {
      margin-top: 19px;
    }
  }
  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: flex-end;
    margin: 24px 0;
    .F-2-text {
      width: 60px;
      height: 13px;
      cursor: pointer;
      font-size: 14px;
      color: #666;
    }
  }
}
.login-re {
  text-align: center;
  margin-top: 20px;
  span {
    text-decoration: underline;
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }
}
</style>